import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/solicitudes-percepciones-empleados';

/**
 * GET Solicitudes Percepciones Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSolicitudesPercepcionesEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Solicitud Percepcion Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSolicitudPercepcionEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Solicitud Percepcion Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSolicitudPercepcionEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Solicitud Percepcion Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSolicitudPercepcionEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Solicitud Percepcion Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSolicitudPercepcionEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Solicitudes Percepciones Empleados
 * @param {Array} values
 * @returns {Promise<boolean>}
 */
export const postSolicitudesPercepcionesEmpleados = async (values) => {
  try {
    const URI = 'nominas/agregar-solicitudes-percepciones-empleados/';
    const mensaje = values?.length > 1 ? 'Agregados correctamente' : 'Agregado correctamente';
    const response = await API.post(URI, values);
    onSuccess(response, mensaje);
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * Cargar Plantilla Excel
 * @param {FormData} formData
 * @returns {Promise<object>}
 */
export const cargarPlantillaSolicitudPercepcion = async (formData) => {
  try {
    // Se concatena la acción a la baseURI
    const response = await API.post(`${baseURI}/cargar-plantilla/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    // Si tu backend devuelve un mensaje global
    if (response.data && response.data.message) {
      onSuccess(response.data.message);
    }
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * Quitar todos los empleados de una Solicitud de Percepción (soft-delete masivo)
 * @param {{ solicitud_percepcion_id: number }} values
 * @returns {Promise<object|false>}
 */
export const quitarTodosEmpleadosSolicitudPercepcion = async (values) => {
  try {
    const response = await API.post(`${baseURI}/quitar-todos/`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Obtener Plantilla Excel
 * @returns {Promise<any>}
 */
export const getSolicitudPercepcionPlantillaExcel = async () => {
  try {
    const response = await API.get('nominas/solicitudes-percepciones-empleados-obtener-plantilla-excel/', {
      headers: {
        'Content-Type': 'application/ms-excel',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
